export default {
  deposit: {
    crypto: 'Crypto',
    fiatOrCash: 'Fiat/Cash',
    depositCurrency: 'Deposit na Pera',
    chooseNetwork: 'Pumili ng Network',
    depositAddress: 'Deposit address',
    copy: 'Kopyahin',
    copied: 'Nakopya!',
    close: 'Isara',
    more: 'Higit pa',
    select: 'Pumili',
    channel: 'Channel',
    loading: 'Naglo-load...',
    noCurrency: 'Walang available na pera',
    bonusTip: 'Mag-enjoy ng deposit bonus sa unang recharge mo, na may hanggang 200% dagdag na credit.',
    minDeposit: 'Pinakamababang Deposit',
    sendOnly: 'Magpadala lamang ng {currency} sa deposit address na ito. Ang mga coin ay awtomatikong ide-deposit pagkatapos ng {confirmations} network confirmation.',
    depositAmount: 'Halaga ng Deposit',
    enterAmount: 'Ilagay ang halaga',
    confirmDeposit: 'Kumpirmahin ang Deposit',
    depositTitle: 'Deposit',
    selectChannel: 'Pumili ng Channel',
    subtitle: 'Mabilis, ligtas at maginhawa',
    secureEncrypted: 'Ligtas at Naka-encrypt',
    terms: 'Sa pagpapatuloy, sumasang-ayon ka sa aming Mga Tuntunin at Kondisyon',
    totalDepositAmount: 'Kabuuang halaga ng deposit',
    fee: 'Bayarin',
    arrivalAmount: 'Halagang na-kredito',
    payMethod: 'Paraan ng Pagbabayad',
    cpf: 'CPF',
    enterCpf: 'Pakilagay ang iyong CPF',
    depositSuccess: 'Matagumpay ang deposit!',
    depositFailed: 'Nabigo ang deposit, subukan muli.',
    mockArrive: 'Pekeng Pagdating (Pagsubok)',
    activity: {
      firstChargeTitle: 'Event ng Pagpaparehistro ng Unang Recharge',
      firstChargeSubtitle: 'Irehistro ang iyong unang deposit para makatanggap ng eksklusibong gantimpala',
      dailyThreeTitle: 'Tatlong Recharge Araw-araw',
      dailyThreeSubtitle: 'Kumpletuhin ang 3 deposit kada araw para mag-claim ng dagdag na bonus',
      dailyPreviewLabel: 'Gantimpala sa Unang Recharge',
      upTo: 'Hanggang {amount} {unit}',
      safeTitle: 'Ligtas ang iyong pondo sa amin',
      safeDesc: 'Gumagamit kami ng nangungunang seguridad sa industriya para protektahan ang iyong mga transaksyon at personal na impormasyon.',
      dailyFirst: 'Unang Recharge Araw-araw',
      dailySecond: 'Pangalawang Recharge Araw-araw',
      dailyThird: 'Pangatlong Recharge Araw-araw',
      lossReward: 'Loss Rebate',
      lossRewardSubtitle: 'Kumuha ng cashback sa iyong mga pagkalugi',
      rebateUpTo: 'Rebate hanggang {ratio}%',
      notEligible: 'Hindi ka na kwalipikado para sa aktibidad na ito',
      lossNeedSelect: 'Piliin ang aktibidad na ito kapag nagdeposito para sumali sa cashback',
      claimed: 'Naangkin na',
      claim: 'Angkinin',
      noTier: 'Walang tier',
      claimWillOpen: 'Magbubukas ang claim sa {time}',
      claimTimeNotReached: 'Hindi pa bukas ang claim. Bumalik pagkatapos ng {time}.',
      bonus: 'Bonus',
      rebate: 'Rebate',
      depositGE: 'Deposit ≥ {amount}',
      lossGE: 'Pagkawala ≥ {amount}',
      claimSuccess: 'Matagumpay na naangkin',
      claimFailed: 'Nabigo ang pag-angkin',
      alreadyClaimed: 'Naangkin mo na ang tier na ito. Huwag na mag-click ulit.',
      lossAlreadyClaimed: 'Naangkin mo na ang loss rebate ng tier na ito. Huwag na mag-click ulit.',
      requireLogin: 'Mag-login muna bago mag-claim.',
      depositNotEnough: 'Hindi pa sapat ang halaga ng iyong deposit. Magpatuloy!',
      lossNotEnough: 'Hindi sapat ang halaga ng iyong pagkawala kahapon.',
      onlyHighest: 'Ang gantimpala ng aktibidad na ito ay para lang sa pinakamataas na antas.',
    },
  },
};
